import * as CloudActions from './../actions/cloud.actions';
import { TechnicalError } from '@dch/products-business-logic';

export interface CloudState {
  price: any;
  isPendingPrice: boolean;
  errorPrice: TechnicalError;
  accountActive: boolean;
  login: string;
  accountStatusFetchedSuccess: boolean;
  isAccountStatusFetching: boolean;
  accountStatusError: TechnicalError;
  accountActivationSuccess: boolean;
  isAccountActivationPending: boolean;
  accountActivationError: TechnicalError;
}

export const initialState: CloudState = {
  price: [],
  isPendingPrice: false,
  errorPrice: null,
  accountActive: false,
  login: undefined,
  accountStatusFetchedSuccess: false,
  isAccountStatusFetching: false,
  accountStatusError: null,
  accountActivationSuccess: false,
  isAccountActivationPending: false,
  accountActivationError: null,
};

export function reducer(
  state: CloudState = initialState,
  action: CloudActions.Actions,
): CloudState {
  switch (action.type) {
    case CloudActions.GET_CLOUD_PRODUCT_PRICE:
      return {
        ...state,
        isPendingPrice: true,
        errorPrice: null,
      };
    case CloudActions.GET_CLOUD_PRODUCT_PRICE_SUCCESS:
      return {
        ...state,
        price: action.payload.responses[0],
        isPendingPrice: false,
        errorPrice: null,
      };
    case CloudActions.GET_CLOUD_PRODUCT_PRICE_FAILED:
      return {
        ...state,
        price: null,
        errorPrice: action.payload,
        isPendingPrice: false,
      };
    case CloudActions.GET_CLOUD_ACTIVATION_STATUS:
      return {
        ...state,
        isAccountStatusFetching: true,
        accountStatusFetchedSuccess: false,
        accountStatusError: null,
      };
    case CloudActions.GET_CLOUD_ACTIVATION_STATUS_SUCCESS:
      return {
        ...state,
        isAccountStatusFetching: false,
        accountActive: action.payload.active,
        login: action.payload.userLogin,
        accountStatusFetchedSuccess: true,
        accountStatusError: null,
      };
    case CloudActions.GET_CLOUD_ACTIVATION_STATUS_NO_CHANGE:
      return {
        ...state,
        isAccountStatusFetching: false,
        accountStatusFetchedSuccess: true,
        accountStatusError: null,
      };
    case CloudActions.GET_CLOUD_ACTIVATION_STATUS_FAILED:
      return {
        ...state,
        isAccountStatusFetching: false,
        accountActive: false,
        login: undefined,
        accountStatusFetchedSuccess: false,
        accountStatusError: action.payload,
      };
    case CloudActions.ACTIVATE_CLOUD_ACCOUNT:
      return {
        ...state,
        isAccountActivationPending: true,
        accountActivationSuccess: false,
        accountActivationError: null,
      };
    case CloudActions.ACTIVATE_CLOUD_ACCOUNT_SUCCESS:
      return {
        ...state,
        isAccountActivationPending: false,
        accountActivationSuccess: true,
        accountActivationError: null,
      };
    case CloudActions.ACTIVATE_CLOUD_ACCOUNT_FAILED:
      return {
        ...state,
        isAccountActivationPending: false,
        accountActivationSuccess: false,
        accountActivationError: action.payload,
      };

    default:
      return state;
  }
}

export const getProductsPrice = (state: CloudState) => state.price;
export const getProductsPriceTechnicalError = (state: CloudState) =>
  state.errorPrice;
export const getProductsPricePending = (state: CloudState) =>
  state.isPendingPrice;

export const getAccountActive = (state: CloudState) => state.accountActive;
export const getAccountLogin = (state: CloudState) => state.login;
export const getAccountStatusFetchedSuccess = (state: CloudState) =>
  state.accountStatusFetchedSuccess;
export const getAccountStatusFetching = (state: CloudState) =>
  state.isAccountStatusFetching;
export const getAccountStatusError = (state: CloudState) =>
  state.accountStatusError;

export const getAccountActivationSuccess = (state: CloudState) =>
  state.accountActivationSuccess;
export const getAccountActivationPending = (state: CloudState) =>
  state.isAccountActivationPending;
export const getAccountActivationError = (state: CloudState) =>
  state.accountActivationError;
